import { Component } from '@angular/core';

@Component({
  selector: 'ngx-footer',
  styleUrls: ['./footer.component.scss'],
  template: `
    <span class="created-by">
      Powered by <b><a href="https://foodfactor.pl" target="_blank">Food Factor</a></b> 2021
    </span>
  `,
})
export class FooterComponent {
}
